import { dealerApi } from './dealerApi';

export const dealerPlans = {
  me: () => dealerApi.get('/dealers/me/plan').then((r) => r.data),
};

// Admin actions use the regular `axios` client (with admin session JWT)
import axios from 'axios';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const adminAuthHeader = () => {
  const t = localStorage.getItem('admin_token');
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const adminPlans = {
  catalog: () => axios.get(`${API}/admin/plans`, { headers: adminAuthHeader() }).then((r) => r.data),
  listDealers: () => axios.get(`${API}/admin/dealers/plans`, { headers: adminAuthHeader() }).then((r) => r.data),
  setPlan: (dealerId, plan) =>
    axios.patch(`${API}/admin/dealers/${dealerId}/plan`, { plan }, { headers: adminAuthHeader() }).then((r) => r.data),
  setFeatures: (dealerId, features) =>
    axios.patch(`${API}/admin/dealers/${dealerId}/features`, { features }, { headers: adminAuthHeader() }).then((r) => r.data),
};
